// This file is auto-generated by @hey-api/openapi-ts

import type { Options } from "@hey-api/client-fetch";
import {
  queryOptions,
  type UseMutationOptions,
  type DefaultError,
  infiniteQueryOptions,
  type InfiniteData,
} from "@tanstack/react-query";
import type {
  GetV1OrganizationsByOrganizationIdLeadsData,
  CreateLeadData,
  CreateLeadError,
  CreateLeadResponse,
  GetV1OrganizationsByOrganizationIdArchivedLeadsData,
  PostV1QueryAssignmentData,
  PostV1QueryAssignmentError,
  PostV1QueryAssignmentResponse,
  GetV1QueryClientInfoData,
  PostV1ProfilesData,
  PostV1ProfilesError,
  PostV1ProfilesResponse,
  GetV1ProfilesByProfileIdData,
  PutV1ProfilesByProfileIdData,
  PutV1ProfilesByProfileIdError,
  PutV1ProfilesByProfileIdResponse,
  DeleteV1ProfilesByProfileIdData,
  PostV1OrganizationsByOrganizationIdProfilesByProfileIdUploadResumeData,
  PostV1OrganizationsByOrganizationIdProfilesByProfileIdUploadResumeError,
  PostV1OrganizationsByOrganizationIdProfilesByProfileIdUploadResumeResponse,
  GetV1OrganizationsByOrganizationIdData,
  PutV1OrganizationsByOrganizationIdData,
  PutV1OrganizationsByOrganizationIdError,
  PutV1OrganizationsByOrganizationIdResponse,
  GetV1OrganizationsInfoByOrganizationIdData,
  PutV1OrganizationsByOrganizationIdLeadsByLeadIdData,
  PutV1OrganizationsByOrganizationIdLeadsByLeadIdError,
  PutV1OrganizationsByOrganizationIdLeadsByLeadIdResponse,
  DeleteV1OrganizationsByOrganizationIdLeadsByLeadIdData,
  DeleteV1OrganizationsByOrganizationIdLeadsByLeadIdError,
  DeleteV1OrganizationsByOrganizationIdLeadsByLeadIdResponse,
  GetV1JobsData,
  GetV1MultipleJobsData,
  PutV1OrganizationsByOrganizationIdClientsByClientIdData,
  PutV1OrganizationsByOrganizationIdClientsByClientIdError,
  PutV1OrganizationsByOrganizationIdClientsByClientIdResponse,
  GetV2pByProfileLinkData,
  GetV1CommentsByResourceIdData,
  DeleteV1CommentsByResourceIdData,
  DeleteV1CommentsByResourceIdError,
  DeleteV1CommentsByResourceIdResponse,
  PostV1CommentsData,
  PostV1CommentsError,
  PostV1CommentsResponse,
  PostV1LeadsByLeadIdContractsData,
  PostV1LeadsByLeadIdContractsError,
  PostV1LeadsByLeadIdContractsResponse,
  PutV1LeadsByLeadIdContractsByContractIdData,
  PutV1LeadsByLeadIdContractsByContractIdError,
  PutV1LeadsByLeadIdContractsByContractIdResponse,
  DeleteV1LeadsByLeadIdContractsByContractIdData,
  DeleteV1LeadsByLeadIdContractsByContractIdError,
  DeleteV1LeadsByLeadIdContractsByContractIdResponse,
  GetV1OrganizationsByOrganizationIdProfilesByProfileIdLeadsData,
  GetV1OrganizationsByOrganizationIdProfilesByProfileIdData,
  PutV1OrganizationsByOrganizationIdProfilesByProfileIdData,
  PutV1OrganizationsByOrganizationIdProfilesByProfileIdError,
  PutV1OrganizationsByOrganizationIdProfilesByProfileIdResponse,
  PutV1OrganizationsByOrganizationIdProfilesByProfileIdEmailData,
  PutV1OrganizationsByOrganizationIdProfilesByProfileIdEmailError,
  PutV1OrganizationsByOrganizationIdProfilesByProfileIdEmailResponse,
  GetV1OrganizationsByOrganizationIdProfilesData,
  PostV1OrganizationsByOrganizationIdProfilesData,
  PostV1OrganizationsByOrganizationIdProfilesError,
  PostV1OrganizationsByOrganizationIdProfilesResponse,
  PostV2OrganizationsByOrganizationIdProfilesData,
  PostV2OrganizationsByOrganizationIdProfilesError,
  PostV2OrganizationsByOrganizationIdProfilesResponse,
  SearchSkillsData,
  GetV1OrganizationsByOrganizationIdSkillsData,
  GetV1OrganizationsByOrganizationIdMatchData,
  GetV1OrganizationsByOrganizationIdProfilesByProfileIdMatchData,
  GetV1OrganizationsByOrganizationIdLeadsByLeadIdMatchData,
  GetV1OrganizationByOrganizationIdContactData,
  PutV1NotificationsByResourceIdData,
  PutV1NotificationsByResourceIdError,
  PutV1NotificationsByResourceIdResponse,
  PostV1AssignmentData,
  PostV1AssignmentError,
  PostV1AssignmentResponse,
  PostV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentGenerateData,
  PostV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentGenerateError,
  PostV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentGenerateResponse,
  GetV1OrganisationsByOrganizationIdClientsData,
  PostV1OrganisationsByOrganizationIdClientsData,
  PostV1OrganisationsByOrganizationIdClientsError,
  PostV1OrganisationsByOrganizationIdClientsResponse,
  PutV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentMotivationByLinkIdData,
  PutV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentMotivationByLinkIdError,
  PutV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentMotivationByLinkIdResponse,
  PostV1SkillsCategoriesData,
  PostV1SkillsCategoriesError,
  PostV1SkillsCategoriesResponse,
  GetV1LinksByProfileLinkData,
  PutV1LinksByProfileLinkData,
  PutV1LinksByProfileLinkError,
  PutV1LinksByProfileLinkResponse,
  GetV1LinksByProfileLinkSettingsData,
  GetV1LinksByProfileLinkWordData,
  PutV1LinksByProfileLinkResetData,
  PutV1LinksByProfileLinkResetError,
  PutV1LinksByProfileLinkResetResponse,
  PostV1LinksByProfileLinkContactsData,
  PostV1LinksByProfileLinkContactsError,
  PostV1LinksByProfileLinkContactsResponse,
  GetV1OrganizationsByOrganizationIdAssignmentsData,
  PostV1OrganizationsByOrganizationIdAssignmentsData,
  PostV1OrganizationsByOrganizationIdAssignmentsError,
  PostV1OrganizationsByOrganizationIdAssignmentsResponse,
  PutV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdData,
  PutV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdError,
  PutV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdResponse,
  DeleteV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdData,
  DeleteV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdError,
  DeleteV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdResponse,
  PostV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdGenerateData,
  PostV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdGenerateError,
  PostV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdGenerateResponse,
  PostV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdLeadData,
  PostV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdLeadError,
  PostV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdLeadResponse,
  PostV1OrganizationsByOrganizationIdSemanticMatchData,
  PostV1OrganizationsByOrganizationIdSemanticMatchError,
  PostV1OrganizationsByOrganizationIdSemanticMatchResponse,
  GetV1OrganizationsByOrganizationIdLeadsByLeadIdMatchStreamData,
  GetV1OrganizationsByOrganizationIdActiveLeadJobsData,
  PostV1OrganizationsByOrganizationIdProfilesByProfileIdSemanticMatchData,
  PostV1OrganizationsByOrganizationIdProfilesByProfileIdSemanticMatchError,
  PostV1OrganizationsByOrganizationIdProfilesByProfileIdSemanticMatchResponse,
  GetV1OrganizationsByOrganizationIdLeadsByLeadIdMatchResultsData,
} from "../types.gen";
import {
  client,
  getV1OrganizationsByOrganizationIdLeads,
  createLead,
  getV1OrganizationsByOrganizationIdArchivedLeads,
  postV1QueryAssignment,
  getV1QueryClientInfo,
  getV1Profiles,
  postV1Profiles,
  getV1ProfilesByProfileId,
  putV1ProfilesByProfileId,
  deleteV1ProfilesByProfileId,
  postV1OrganizationsByOrganizationIdProfilesByProfileIdUploadResume,
  getV1OrganizationsByOrganizationId,
  putV1OrganizationsByOrganizationId,
  getV1OrganizationsInfoByOrganizationId,
  putV1OrganizationsByOrganizationIdLeadsByLeadId,
  deleteV1OrganizationsByOrganizationIdLeadsByLeadId,
  getV1Jobs,
  getV1MultipleJobs,
  putV1OrganizationsByOrganizationIdClientsByClientId,
  getV2PByProfileLink,
  getV1CommentsByResourceId,
  deleteV1CommentsByResourceId,
  postV1Comments,
  postV1LeadsByLeadIdContracts,
  putV1LeadsByLeadIdContractsByContractId,
  deleteV1LeadsByLeadIdContractsByContractId,
  getV1OrganizationsByOrganizationIdProfilesByProfileIdLeads,
  getV1OrganizationsByOrganizationIdProfilesByProfileId,
  putV1OrganizationsByOrganizationIdProfilesByProfileId,
  putV1OrganizationsByOrganizationIdProfilesByProfileIdEmail,
  getV1OrganizationsByOrganizationIdProfiles,
  postV1OrganizationsByOrganizationIdProfiles,
  postV2OrganizationsByOrganizationIdProfiles,
  searchSkills,
  getV1OrganizationsByOrganizationIdSkills,
  getV1OrganizationsByOrganizationIdMatch,
  getV1OrganizationsByOrganizationIdProfilesByProfileIdMatch,
  getV1OrganizationsByOrganizationIdLeadsByLeadIdMatch,
  getV1OrganizationByOrganizationIdContact,
  putV1NotificationsByResourceId,
  postV1Assignment,
  postV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentGenerate,
  getV1Users,
  getV1OrganisationsByOrganizationIdClients,
  postV1OrganisationsByOrganizationIdClients,
  putV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentMotivationByLinkId,
  postV1SkillsCategories,
  getV1LinksByProfileLink,
  putV1LinksByProfileLink,
  getV1LinksByProfileLinkSettings,
  getV1LinksByProfileLinkWord,
  putV1LinksByProfileLinkReset,
  postV1LinksByProfileLinkContacts,
  getV1OrganizationsByOrganizationIdAssignments,
  postV1OrganizationsByOrganizationIdAssignments,
  putV1OrganizationsByOrganizationIdAssignmentsByAssignmentId,
  deleteV1OrganizationsByOrganizationIdAssignmentsByAssignmentId,
  postV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdGenerate,
  postV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdLead,
  postV1OrganizationsByOrganizationIdSemanticMatch,
  getV1OrganizationsByOrganizationIdLeadsByLeadIdMatchStream,
  getV1OrganizationsByOrganizationIdActiveLeadJobs,
  postV1OrganizationsByOrganizationIdProfilesByProfileIdSemanticMatch,
  getV1OrganizationsByOrganizationIdLeadsByLeadIdMatchResults,
} from "../services.gen";

type QueryKey<TOptions extends Options> = [
  Pick<TOptions, "baseUrl" | "body" | "headers" | "path" | "query"> & {
    _id: string;
    _infinite?: boolean;
  },
];

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean
): QueryKey<TOptions>[0] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl: (options?.client ?? client).getConfig().baseUrl,
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return params;
};

export const getV1OrganizationsByOrganizationIdLeadsQueryKey = (
  options: Options<GetV1OrganizationsByOrganizationIdLeadsData>
) => [createQueryKey("getV1OrganizationsByOrganizationIdLeads", options)];

export const getV1OrganizationsByOrganizationIdLeadsOptions = (
  options: Options<GetV1OrganizationsByOrganizationIdLeadsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await getV1OrganizationsByOrganizationIdLeads({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: getV1OrganizationsByOrganizationIdLeadsQueryKey(options),
  });
};

export const createLeadQueryKey = (options: Options<CreateLeadData>) => [
  createQueryKey("createLead", options),
];

export const createLeadOptions = (options: Options<CreateLeadData>) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await createLead({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: createLeadQueryKey(options),
  });
};

export const createLeadMutation = (options?: Partial<Options<CreateLeadData>>) => {
  const mutationOptions: UseMutationOptions<
    CreateLeadResponse,
    CreateLeadError,
    Options<CreateLeadData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createLead({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getV1OrganizationsByOrganizationIdArchivedLeadsQueryKey = (
  options: Options<GetV1OrganizationsByOrganizationIdArchivedLeadsData>
) => [createQueryKey("getV1OrganizationsByOrganizationIdArchivedLeads", options)];

export const getV1OrganizationsByOrganizationIdArchivedLeadsOptions = (
  options: Options<GetV1OrganizationsByOrganizationIdArchivedLeadsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await getV1OrganizationsByOrganizationIdArchivedLeads({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: getV1OrganizationsByOrganizationIdArchivedLeadsQueryKey(options),
  });
};

export const postV1QueryAssignmentQueryKey = (options: Options<PostV1QueryAssignmentData>) => [
  createQueryKey("postV1QueryAssignment", options),
];

export const postV1QueryAssignmentOptions = (options: Options<PostV1QueryAssignmentData>) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await postV1QueryAssignment({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: postV1QueryAssignmentQueryKey(options),
  });
};

export const postV1QueryAssignmentMutation = (
  options?: Partial<Options<PostV1QueryAssignmentData>>
) => {
  const mutationOptions: UseMutationOptions<
    PostV1QueryAssignmentResponse,
    PostV1QueryAssignmentError,
    Options<PostV1QueryAssignmentData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postV1QueryAssignment({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getV1QueryClientInfoQueryKey = (options: Options<GetV1QueryClientInfoData>) => [
  createQueryKey("getV1QueryClientInfo", options),
];

export const getV1QueryClientInfoOptions = (options: Options<GetV1QueryClientInfoData>) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await getV1QueryClientInfo({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: getV1QueryClientInfoQueryKey(options),
  });
};

export const getV1ProfilesQueryKey = (options?: Options) => [
  createQueryKey("getV1Profiles", options),
];

export const getV1ProfilesOptions = (options?: Options) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await getV1Profiles({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: getV1ProfilesQueryKey(options),
  });
};

export const postV1ProfilesQueryKey = (options: Options<PostV1ProfilesData>) => [
  createQueryKey("postV1Profiles", options),
];

export const postV1ProfilesOptions = (options: Options<PostV1ProfilesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await postV1Profiles({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: postV1ProfilesQueryKey(options),
  });
};

export const postV1ProfilesMutation = (options?: Partial<Options<PostV1ProfilesData>>) => {
  const mutationOptions: UseMutationOptions<
    PostV1ProfilesResponse,
    PostV1ProfilesError,
    Options<PostV1ProfilesData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postV1Profiles({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getV1ProfilesByProfileIdQueryKey = (
  options: Options<GetV1ProfilesByProfileIdData>
) => [createQueryKey("getV1ProfilesByProfileId", options)];

export const getV1ProfilesByProfileIdOptions = (options: Options<GetV1ProfilesByProfileIdData>) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await getV1ProfilesByProfileId({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: getV1ProfilesByProfileIdQueryKey(options),
  });
};

export const putV1ProfilesByProfileIdMutation = (
  options?: Partial<Options<PutV1ProfilesByProfileIdData>>
) => {
  const mutationOptions: UseMutationOptions<
    PutV1ProfilesByProfileIdResponse,
    PutV1ProfilesByProfileIdError,
    Options<PutV1ProfilesByProfileIdData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await putV1ProfilesByProfileId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const deleteV1ProfilesByProfileIdMutation = (
  options?: Partial<Options<DeleteV1ProfilesByProfileIdData>>
) => {
  const mutationOptions: UseMutationOptions<
    void,
    DefaultError,
    Options<DeleteV1ProfilesByProfileIdData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteV1ProfilesByProfileId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postV1OrganizationsByOrganizationIdProfilesByProfileIdUploadResumeQueryKey = (
  options: Options<PostV1OrganizationsByOrganizationIdProfilesByProfileIdUploadResumeData>
) => [
  createQueryKey("postV1OrganizationsByOrganizationIdProfilesByProfileIdUploadResume", options),
];

export const postV1OrganizationsByOrganizationIdProfilesByProfileIdUploadResumeOptions = (
  options: Options<PostV1OrganizationsByOrganizationIdProfilesByProfileIdUploadResumeData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await postV1OrganizationsByOrganizationIdProfilesByProfileIdUploadResume({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: postV1OrganizationsByOrganizationIdProfilesByProfileIdUploadResumeQueryKey(options),
  });
};

export const postV1OrganizationsByOrganizationIdProfilesByProfileIdUploadResumeMutation = (
  options?: Partial<Options<PostV1OrganizationsByOrganizationIdProfilesByProfileIdUploadResumeData>>
) => {
  const mutationOptions: UseMutationOptions<
    PostV1OrganizationsByOrganizationIdProfilesByProfileIdUploadResumeResponse,
    PostV1OrganizationsByOrganizationIdProfilesByProfileIdUploadResumeError,
    Options<PostV1OrganizationsByOrganizationIdProfilesByProfileIdUploadResumeData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postV1OrganizationsByOrganizationIdProfilesByProfileIdUploadResume({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getV1OrganizationsByOrganizationIdQueryKey = (
  options: Options<GetV1OrganizationsByOrganizationIdData>
) => [createQueryKey("getV1OrganizationsByOrganizationId", options)];

export const getV1OrganizationsByOrganizationIdOptions = (
  options: Options<GetV1OrganizationsByOrganizationIdData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await getV1OrganizationsByOrganizationId({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: getV1OrganizationsByOrganizationIdQueryKey(options),
  });
};

export const putV1OrganizationsByOrganizationIdMutation = (
  options?: Partial<Options<PutV1OrganizationsByOrganizationIdData>>
) => {
  const mutationOptions: UseMutationOptions<
    PutV1OrganizationsByOrganizationIdResponse,
    PutV1OrganizationsByOrganizationIdError,
    Options<PutV1OrganizationsByOrganizationIdData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await putV1OrganizationsByOrganizationId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getV1OrganizationsInfoByOrganizationIdQueryKey = (
  options: Options<GetV1OrganizationsInfoByOrganizationIdData>
) => [createQueryKey("getV1OrganizationsInfoByOrganizationId", options)];

export const getV1OrganizationsInfoByOrganizationIdOptions = (
  options: Options<GetV1OrganizationsInfoByOrganizationIdData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await getV1OrganizationsInfoByOrganizationId({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: getV1OrganizationsInfoByOrganizationIdQueryKey(options),
  });
};

export const putV1OrganizationsByOrganizationIdLeadsByLeadIdMutation = (
  options?: Partial<Options<PutV1OrganizationsByOrganizationIdLeadsByLeadIdData>>
) => {
  const mutationOptions: UseMutationOptions<
    PutV1OrganizationsByOrganizationIdLeadsByLeadIdResponse,
    PutV1OrganizationsByOrganizationIdLeadsByLeadIdError,
    Options<PutV1OrganizationsByOrganizationIdLeadsByLeadIdData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await putV1OrganizationsByOrganizationIdLeadsByLeadId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const deleteV1OrganizationsByOrganizationIdLeadsByLeadIdMutation = (
  options?: Partial<Options<DeleteV1OrganizationsByOrganizationIdLeadsByLeadIdData>>
) => {
  const mutationOptions: UseMutationOptions<
    DeleteV1OrganizationsByOrganizationIdLeadsByLeadIdResponse,
    DeleteV1OrganizationsByOrganizationIdLeadsByLeadIdError,
    Options<DeleteV1OrganizationsByOrganizationIdLeadsByLeadIdData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteV1OrganizationsByOrganizationIdLeadsByLeadId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getV1JobsQueryKey = (options: Options<GetV1JobsData>) => [
  createQueryKey("getV1Jobs", options),
];

export const getV1JobsOptions = (options: Options<GetV1JobsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await getV1Jobs({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: getV1JobsQueryKey(options),
  });
};

export const getV1MultipleJobsQueryKey = (options: Options<GetV1MultipleJobsData>) => [
  createQueryKey("getV1MultipleJobs", options),
];

export const getV1MultipleJobsOptions = (options: Options<GetV1MultipleJobsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await getV1MultipleJobs({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: getV1MultipleJobsQueryKey(options),
  });
};

export const putV1OrganizationsByOrganizationIdClientsByClientIdMutation = (
  options?: Partial<Options<PutV1OrganizationsByOrganizationIdClientsByClientIdData>>
) => {
  const mutationOptions: UseMutationOptions<
    PutV1OrganizationsByOrganizationIdClientsByClientIdResponse,
    PutV1OrganizationsByOrganizationIdClientsByClientIdError,
    Options<PutV1OrganizationsByOrganizationIdClientsByClientIdData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await putV1OrganizationsByOrganizationIdClientsByClientId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getV2PByProfileLinkQueryKey = (options: Options<GetV2pByProfileLinkData>) => [
  createQueryKey("getV2PByProfileLink", options),
];

export const getV2PByProfileLinkOptions = (options: Options<GetV2pByProfileLinkData>) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await getV2PByProfileLink({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: getV2PByProfileLinkQueryKey(options),
  });
};

export const getV1CommentsByResourceIdQueryKey = (
  options: Options<GetV1CommentsByResourceIdData>
) => [createQueryKey("getV1CommentsByResourceId", options)];

export const getV1CommentsByResourceIdOptions = (
  options: Options<GetV1CommentsByResourceIdData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await getV1CommentsByResourceId({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: getV1CommentsByResourceIdQueryKey(options),
  });
};

export const deleteV1CommentsByResourceIdMutation = (
  options?: Partial<Options<DeleteV1CommentsByResourceIdData>>
) => {
  const mutationOptions: UseMutationOptions<
    DeleteV1CommentsByResourceIdResponse,
    DeleteV1CommentsByResourceIdError,
    Options<DeleteV1CommentsByResourceIdData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteV1CommentsByResourceId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postV1CommentsQueryKey = (options: Options<PostV1CommentsData>) => [
  createQueryKey("postV1Comments", options),
];

export const postV1CommentsOptions = (options: Options<PostV1CommentsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await postV1Comments({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: postV1CommentsQueryKey(options),
  });
};

export const postV1CommentsMutation = (options?: Partial<Options<PostV1CommentsData>>) => {
  const mutationOptions: UseMutationOptions<
    PostV1CommentsResponse,
    PostV1CommentsError,
    Options<PostV1CommentsData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postV1Comments({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postV1LeadsByLeadIdContractsQueryKey = (
  options: Options<PostV1LeadsByLeadIdContractsData>
) => [createQueryKey("postV1LeadsByLeadIdContracts", options)];

export const postV1LeadsByLeadIdContractsOptions = (
  options: Options<PostV1LeadsByLeadIdContractsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await postV1LeadsByLeadIdContracts({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: postV1LeadsByLeadIdContractsQueryKey(options),
  });
};

const createInfiniteParams = <
  K extends Pick<QueryKey<Options>[0], "body" | "headers" | "path" | "query">,
>(
  queryKey: QueryKey<Options>,
  page: K
) => {
  const params = queryKey[0];
  if (page.body) {
    params.body = {
      ...(queryKey[0].body as any),
      ...(page.body as any),
    };
  }
  if (page.headers) {
    params.headers = {
      ...queryKey[0].headers,
      ...page.headers,
    };
  }
  if (page.path) {
    params.path = {
      ...queryKey[0].path,
      ...page.path,
    };
  }
  if (page.query) {
    params.query = {
      ...queryKey[0].query,
      ...page.query,
    };
  }
  return params as unknown as typeof page;
};

export const postV1LeadsByLeadIdContractsInfiniteQueryKey = (
  options: Options<PostV1LeadsByLeadIdContractsData>
): QueryKey<Options<PostV1LeadsByLeadIdContractsData>> => [
  createQueryKey("postV1LeadsByLeadIdContracts", options, true),
];

export const postV1LeadsByLeadIdContractsInfiniteOptions = (
  options: Options<PostV1LeadsByLeadIdContractsData>
) => {
  return infiniteQueryOptions<
    PostV1LeadsByLeadIdContractsResponse,
    PostV1LeadsByLeadIdContractsError,
    InfiniteData<PostV1LeadsByLeadIdContractsResponse>,
    QueryKey<Options<PostV1LeadsByLeadIdContractsData>>,
    | string
    | Pick<
        QueryKey<Options<PostV1LeadsByLeadIdContractsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<PostV1LeadsByLeadIdContractsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                body: {
                  startDate: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await postV1LeadsByLeadIdContracts({
          ...options,
          ...params,
          throwOnError: true,
        });
        return data;
      },
      queryKey: postV1LeadsByLeadIdContractsInfiniteQueryKey(options),
    }
  );
};

export const postV1LeadsByLeadIdContractsMutation = (
  options?: Partial<Options<PostV1LeadsByLeadIdContractsData>>
) => {
  const mutationOptions: UseMutationOptions<
    PostV1LeadsByLeadIdContractsResponse,
    PostV1LeadsByLeadIdContractsError,
    Options<PostV1LeadsByLeadIdContractsData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postV1LeadsByLeadIdContracts({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const putV1LeadsByLeadIdContractsByContractIdMutation = (
  options?: Partial<Options<PutV1LeadsByLeadIdContractsByContractIdData>>
) => {
  const mutationOptions: UseMutationOptions<
    PutV1LeadsByLeadIdContractsByContractIdResponse,
    PutV1LeadsByLeadIdContractsByContractIdError,
    Options<PutV1LeadsByLeadIdContractsByContractIdData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await putV1LeadsByLeadIdContractsByContractId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const deleteV1LeadsByLeadIdContractsByContractIdMutation = (
  options?: Partial<Options<DeleteV1LeadsByLeadIdContractsByContractIdData>>
) => {
  const mutationOptions: UseMutationOptions<
    DeleteV1LeadsByLeadIdContractsByContractIdResponse,
    DeleteV1LeadsByLeadIdContractsByContractIdError,
    Options<DeleteV1LeadsByLeadIdContractsByContractIdData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteV1LeadsByLeadIdContractsByContractId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getV1OrganizationsByOrganizationIdProfilesByProfileIdLeadsQueryKey = (
  options: Options<GetV1OrganizationsByOrganizationIdProfilesByProfileIdLeadsData>
) => [createQueryKey("getV1OrganizationsByOrganizationIdProfilesByProfileIdLeads", options)];

export const getV1OrganizationsByOrganizationIdProfilesByProfileIdLeadsOptions = (
  options: Options<GetV1OrganizationsByOrganizationIdProfilesByProfileIdLeadsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await getV1OrganizationsByOrganizationIdProfilesByProfileIdLeads({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: getV1OrganizationsByOrganizationIdProfilesByProfileIdLeadsQueryKey(options),
  });
};

export const getV1OrganizationsByOrganizationIdProfilesByProfileIdQueryKey = (
  options: Options<GetV1OrganizationsByOrganizationIdProfilesByProfileIdData>
) => [createQueryKey("getV1OrganizationsByOrganizationIdProfilesByProfileId", options)];

export const getV1OrganizationsByOrganizationIdProfilesByProfileIdOptions = (
  options: Options<GetV1OrganizationsByOrganizationIdProfilesByProfileIdData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await getV1OrganizationsByOrganizationIdProfilesByProfileId({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: getV1OrganizationsByOrganizationIdProfilesByProfileIdQueryKey(options),
  });
};

export const putV1OrganizationsByOrganizationIdProfilesByProfileIdMutation = (
  options?: Partial<Options<PutV1OrganizationsByOrganizationIdProfilesByProfileIdData>>
) => {
  const mutationOptions: UseMutationOptions<
    PutV1OrganizationsByOrganizationIdProfilesByProfileIdResponse,
    PutV1OrganizationsByOrganizationIdProfilesByProfileIdError,
    Options<PutV1OrganizationsByOrganizationIdProfilesByProfileIdData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await putV1OrganizationsByOrganizationIdProfilesByProfileId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const putV1OrganizationsByOrganizationIdProfilesByProfileIdEmailMutation = (
  options?: Partial<Options<PutV1OrganizationsByOrganizationIdProfilesByProfileIdEmailData>>
) => {
  const mutationOptions: UseMutationOptions<
    PutV1OrganizationsByOrganizationIdProfilesByProfileIdEmailResponse,
    PutV1OrganizationsByOrganizationIdProfilesByProfileIdEmailError,
    Options<PutV1OrganizationsByOrganizationIdProfilesByProfileIdEmailData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await putV1OrganizationsByOrganizationIdProfilesByProfileIdEmail({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getV1OrganizationsByOrganizationIdProfilesQueryKey = (
  options: Options<GetV1OrganizationsByOrganizationIdProfilesData>
) => [createQueryKey("getV1OrganizationsByOrganizationIdProfiles", options)];

export const getV1OrganizationsByOrganizationIdProfilesOptions = (
  options: Options<GetV1OrganizationsByOrganizationIdProfilesData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await getV1OrganizationsByOrganizationIdProfiles({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: getV1OrganizationsByOrganizationIdProfilesQueryKey(options),
  });
};

export const postV1OrganizationsByOrganizationIdProfilesQueryKey = (
  options: Options<PostV1OrganizationsByOrganizationIdProfilesData>
) => [createQueryKey("postV1OrganizationsByOrganizationIdProfiles", options)];

export const postV1OrganizationsByOrganizationIdProfilesOptions = (
  options: Options<PostV1OrganizationsByOrganizationIdProfilesData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await postV1OrganizationsByOrganizationIdProfiles({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: postV1OrganizationsByOrganizationIdProfilesQueryKey(options),
  });
};

export const postV1OrganizationsByOrganizationIdProfilesMutation = (
  options?: Partial<Options<PostV1OrganizationsByOrganizationIdProfilesData>>
) => {
  const mutationOptions: UseMutationOptions<
    PostV1OrganizationsByOrganizationIdProfilesResponse,
    PostV1OrganizationsByOrganizationIdProfilesError,
    Options<PostV1OrganizationsByOrganizationIdProfilesData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postV1OrganizationsByOrganizationIdProfiles({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postV2OrganizationsByOrganizationIdProfilesQueryKey = (
  options: Options<PostV2OrganizationsByOrganizationIdProfilesData>
) => [createQueryKey("postV2OrganizationsByOrganizationIdProfiles", options)];

export const postV2OrganizationsByOrganizationIdProfilesOptions = (
  options: Options<PostV2OrganizationsByOrganizationIdProfilesData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await postV2OrganizationsByOrganizationIdProfiles({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: postV2OrganizationsByOrganizationIdProfilesQueryKey(options),
  });
};

export const postV2OrganizationsByOrganizationIdProfilesMutation = (
  options?: Partial<Options<PostV2OrganizationsByOrganizationIdProfilesData>>
) => {
  const mutationOptions: UseMutationOptions<
    PostV2OrganizationsByOrganizationIdProfilesResponse,
    PostV2OrganizationsByOrganizationIdProfilesError,
    Options<PostV2OrganizationsByOrganizationIdProfilesData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postV2OrganizationsByOrganizationIdProfiles({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const searchSkillsQueryKey = (options: Options<SearchSkillsData>) => [
  createQueryKey("searchSkills", options),
];

export const searchSkillsOptions = (options: Options<SearchSkillsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await searchSkills({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: searchSkillsQueryKey(options),
  });
};

export const getV1OrganizationsByOrganizationIdSkillsQueryKey = (
  options: Options<GetV1OrganizationsByOrganizationIdSkillsData>
) => [createQueryKey("getV1OrganizationsByOrganizationIdSkills", options)];

export const getV1OrganizationsByOrganizationIdSkillsOptions = (
  options: Options<GetV1OrganizationsByOrganizationIdSkillsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await getV1OrganizationsByOrganizationIdSkills({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: getV1OrganizationsByOrganizationIdSkillsQueryKey(options),
  });
};

export const getV1OrganizationsByOrganizationIdMatchQueryKey = (
  options: Options<GetV1OrganizationsByOrganizationIdMatchData>
) => [createQueryKey("getV1OrganizationsByOrganizationIdMatch", options)];

export const getV1OrganizationsByOrganizationIdMatchOptions = (
  options: Options<GetV1OrganizationsByOrganizationIdMatchData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await getV1OrganizationsByOrganizationIdMatch({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: getV1OrganizationsByOrganizationIdMatchQueryKey(options),
  });
};

export const getV1OrganizationsByOrganizationIdProfilesByProfileIdMatchQueryKey = (
  options: Options<GetV1OrganizationsByOrganizationIdProfilesByProfileIdMatchData>
) => [createQueryKey("getV1OrganizationsByOrganizationIdProfilesByProfileIdMatch", options)];

export const getV1OrganizationsByOrganizationIdProfilesByProfileIdMatchOptions = (
  options: Options<GetV1OrganizationsByOrganizationIdProfilesByProfileIdMatchData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await getV1OrganizationsByOrganizationIdProfilesByProfileIdMatch({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: getV1OrganizationsByOrganizationIdProfilesByProfileIdMatchQueryKey(options),
  });
};

export const getV1OrganizationsByOrganizationIdLeadsByLeadIdMatchQueryKey = (
  options: Options<GetV1OrganizationsByOrganizationIdLeadsByLeadIdMatchData>
) => [createQueryKey("getV1OrganizationsByOrganizationIdLeadsByLeadIdMatch", options)];

export const getV1OrganizationsByOrganizationIdLeadsByLeadIdMatchOptions = (
  options: Options<GetV1OrganizationsByOrganizationIdLeadsByLeadIdMatchData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await getV1OrganizationsByOrganizationIdLeadsByLeadIdMatch({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: getV1OrganizationsByOrganizationIdLeadsByLeadIdMatchQueryKey(options),
  });
};

export const getV1OrganizationByOrganizationIdContactQueryKey = (
  options: Options<GetV1OrganizationByOrganizationIdContactData>
) => [createQueryKey("getV1OrganizationByOrganizationIdContact", options)];

export const getV1OrganizationByOrganizationIdContactOptions = (
  options: Options<GetV1OrganizationByOrganizationIdContactData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await getV1OrganizationByOrganizationIdContact({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: getV1OrganizationByOrganizationIdContactQueryKey(options),
  });
};

export const putV1NotificationsByResourceIdMutation = (
  options?: Partial<Options<PutV1NotificationsByResourceIdData>>
) => {
  const mutationOptions: UseMutationOptions<
    PutV1NotificationsByResourceIdResponse,
    PutV1NotificationsByResourceIdError,
    Options<PutV1NotificationsByResourceIdData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await putV1NotificationsByResourceId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postV1AssignmentQueryKey = (options: Options<PostV1AssignmentData>) => [
  createQueryKey("postV1Assignment", options),
];

export const postV1AssignmentOptions = (options: Options<PostV1AssignmentData>) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await postV1Assignment({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: postV1AssignmentQueryKey(options),
  });
};

export const postV1AssignmentMutation = (options?: Partial<Options<PostV1AssignmentData>>) => {
  const mutationOptions: UseMutationOptions<
    PostV1AssignmentResponse,
    PostV1AssignmentError,
    Options<PostV1AssignmentData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postV1Assignment({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentGenerateQueryKey = (
  options: Options<PostV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentGenerateData>
) => [
  createQueryKey("postV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentGenerate", options),
];

export const postV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentGenerateOptions = (
  options: Options<PostV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentGenerateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await postV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentGenerate({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: postV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentGenerateQueryKey(options),
  });
};

export const postV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentGenerateMutation = (
  options?: Partial<Options<PostV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentGenerateData>>
) => {
  const mutationOptions: UseMutationOptions<
    PostV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentGenerateResponse,
    PostV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentGenerateError,
    Options<PostV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentGenerateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentGenerate({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getV1UsersQueryKey = (options?: Options) => [createQueryKey("getV1Users", options)];

export const getV1UsersOptions = (options?: Options) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await getV1Users({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: getV1UsersQueryKey(options),
  });
};

export const getV1OrganisationsByOrganizationIdClientsQueryKey = (
  options: Options<GetV1OrganisationsByOrganizationIdClientsData>
) => [createQueryKey("getV1OrganisationsByOrganizationIdClients", options)];

export const getV1OrganisationsByOrganizationIdClientsOptions = (
  options: Options<GetV1OrganisationsByOrganizationIdClientsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await getV1OrganisationsByOrganizationIdClients({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: getV1OrganisationsByOrganizationIdClientsQueryKey(options),
  });
};

export const postV1OrganisationsByOrganizationIdClientsQueryKey = (
  options: Options<PostV1OrganisationsByOrganizationIdClientsData>
) => [createQueryKey("postV1OrganisationsByOrganizationIdClients", options)];

export const postV1OrganisationsByOrganizationIdClientsOptions = (
  options: Options<PostV1OrganisationsByOrganizationIdClientsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await postV1OrganisationsByOrganizationIdClients({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: postV1OrganisationsByOrganizationIdClientsQueryKey(options),
  });
};

export const postV1OrganisationsByOrganizationIdClientsMutation = (
  options?: Partial<Options<PostV1OrganisationsByOrganizationIdClientsData>>
) => {
  const mutationOptions: UseMutationOptions<
    PostV1OrganisationsByOrganizationIdClientsResponse,
    PostV1OrganisationsByOrganizationIdClientsError,
    Options<PostV1OrganisationsByOrganizationIdClientsData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postV1OrganisationsByOrganizationIdClients({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const putV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentMotivationByLinkIdMutation = (
  options?: Partial<
    Options<PutV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentMotivationByLinkIdData>
  >
) => {
  const mutationOptions: UseMutationOptions<
    PutV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentMotivationByLinkIdResponse,
    PutV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentMotivationByLinkIdError,
    Options<PutV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentMotivationByLinkIdData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } =
        await putV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentMotivationByLinkId({
          ...options,
          ...localOptions,
          throwOnError: true,
        });
      return data;
    },
  };
  return mutationOptions;
};

export const postV1SkillsCategoriesQueryKey = (options: Options<PostV1SkillsCategoriesData>) => [
  createQueryKey("postV1SkillsCategories", options),
];

export const postV1SkillsCategoriesOptions = (options: Options<PostV1SkillsCategoriesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await postV1SkillsCategories({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: postV1SkillsCategoriesQueryKey(options),
  });
};

export const postV1SkillsCategoriesMutation = (
  options?: Partial<Options<PostV1SkillsCategoriesData>>
) => {
  const mutationOptions: UseMutationOptions<
    PostV1SkillsCategoriesResponse,
    PostV1SkillsCategoriesError,
    Options<PostV1SkillsCategoriesData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postV1SkillsCategories({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getV1LinksByProfileLinkQueryKey = (options: Options<GetV1LinksByProfileLinkData>) => [
  createQueryKey("getV1LinksByProfileLink", options),
];

export const getV1LinksByProfileLinkOptions = (options: Options<GetV1LinksByProfileLinkData>) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await getV1LinksByProfileLink({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: getV1LinksByProfileLinkQueryKey(options),
  });
};

export const putV1LinksByProfileLinkMutation = (
  options?: Partial<Options<PutV1LinksByProfileLinkData>>
) => {
  const mutationOptions: UseMutationOptions<
    PutV1LinksByProfileLinkResponse,
    PutV1LinksByProfileLinkError,
    Options<PutV1LinksByProfileLinkData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await putV1LinksByProfileLink({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getV1LinksByProfileLinkSettingsQueryKey = (
  options: Options<GetV1LinksByProfileLinkSettingsData>
) => [createQueryKey("getV1LinksByProfileLinkSettings", options)];

export const getV1LinksByProfileLinkSettingsOptions = (
  options: Options<GetV1LinksByProfileLinkSettingsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await getV1LinksByProfileLinkSettings({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: getV1LinksByProfileLinkSettingsQueryKey(options),
  });
};

export const getV1LinksByProfileLinkWordQueryKey = (
  options: Options<GetV1LinksByProfileLinkWordData>
) => [createQueryKey("getV1LinksByProfileLinkWord", options)];

export const getV1LinksByProfileLinkWordOptions = (
  options: Options<GetV1LinksByProfileLinkWordData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await getV1LinksByProfileLinkWord({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: getV1LinksByProfileLinkWordQueryKey(options),
  });
};

export const putV1LinksByProfileLinkResetMutation = (
  options?: Partial<Options<PutV1LinksByProfileLinkResetData>>
) => {
  const mutationOptions: UseMutationOptions<
    PutV1LinksByProfileLinkResetResponse,
    PutV1LinksByProfileLinkResetError,
    Options<PutV1LinksByProfileLinkResetData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await putV1LinksByProfileLinkReset({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postV1LinksByProfileLinkContactsQueryKey = (
  options: Options<PostV1LinksByProfileLinkContactsData>
) => [createQueryKey("postV1LinksByProfileLinkContacts", options)];

export const postV1LinksByProfileLinkContactsOptions = (
  options: Options<PostV1LinksByProfileLinkContactsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await postV1LinksByProfileLinkContacts({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: postV1LinksByProfileLinkContactsQueryKey(options),
  });
};

export const postV1LinksByProfileLinkContactsMutation = (
  options?: Partial<Options<PostV1LinksByProfileLinkContactsData>>
) => {
  const mutationOptions: UseMutationOptions<
    PostV1LinksByProfileLinkContactsResponse,
    PostV1LinksByProfileLinkContactsError,
    Options<PostV1LinksByProfileLinkContactsData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postV1LinksByProfileLinkContacts({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getV1OrganizationsByOrganizationIdAssignmentsQueryKey = (
  options: Options<GetV1OrganizationsByOrganizationIdAssignmentsData>
) => [createQueryKey("getV1OrganizationsByOrganizationIdAssignments", options)];

export const getV1OrganizationsByOrganizationIdAssignmentsOptions = (
  options: Options<GetV1OrganizationsByOrganizationIdAssignmentsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await getV1OrganizationsByOrganizationIdAssignments({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: getV1OrganizationsByOrganizationIdAssignmentsQueryKey(options),
  });
};

export const postV1OrganizationsByOrganizationIdAssignmentsQueryKey = (
  options: Options<PostV1OrganizationsByOrganizationIdAssignmentsData>
) => [createQueryKey("postV1OrganizationsByOrganizationIdAssignments", options)];

export const postV1OrganizationsByOrganizationIdAssignmentsOptions = (
  options: Options<PostV1OrganizationsByOrganizationIdAssignmentsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await postV1OrganizationsByOrganizationIdAssignments({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: postV1OrganizationsByOrganizationIdAssignmentsQueryKey(options),
  });
};

export const postV1OrganizationsByOrganizationIdAssignmentsMutation = (
  options?: Partial<Options<PostV1OrganizationsByOrganizationIdAssignmentsData>>
) => {
  const mutationOptions: UseMutationOptions<
    PostV1OrganizationsByOrganizationIdAssignmentsResponse,
    PostV1OrganizationsByOrganizationIdAssignmentsError,
    Options<PostV1OrganizationsByOrganizationIdAssignmentsData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postV1OrganizationsByOrganizationIdAssignments({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const putV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdMutation = (
  options?: Partial<Options<PutV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdData>>
) => {
  const mutationOptions: UseMutationOptions<
    PutV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdResponse,
    PutV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdError,
    Options<PutV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await putV1OrganizationsByOrganizationIdAssignmentsByAssignmentId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const deleteV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdMutation = (
  options?: Partial<Options<DeleteV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdData>>
) => {
  const mutationOptions: UseMutationOptions<
    DeleteV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdResponse,
    DeleteV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdError,
    Options<DeleteV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteV1OrganizationsByOrganizationIdAssignmentsByAssignmentId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdGenerateQueryKey = (
  options: Options<PostV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdGenerateData>
) => [
  createQueryKey("postV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdGenerate", options),
];

export const postV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdGenerateOptions = (
  options: Options<PostV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdGenerateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await postV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdGenerate({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: postV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdGenerateQueryKey(options),
  });
};

export const postV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdGenerateMutation = (
  options?: Partial<
    Options<PostV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdGenerateData>
  >
) => {
  const mutationOptions: UseMutationOptions<
    PostV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdGenerateResponse,
    PostV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdGenerateError,
    Options<PostV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdGenerateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdGenerate({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdLeadQueryKey = (
  options: Options<PostV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdLeadData>
) => [createQueryKey("postV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdLead", options)];

export const postV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdLeadOptions = (
  options: Options<PostV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdLeadData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await postV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdLead({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: postV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdLeadQueryKey(options),
  });
};

export const postV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdLeadMutation = (
  options?: Partial<Options<PostV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdLeadData>>
) => {
  const mutationOptions: UseMutationOptions<
    PostV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdLeadResponse,
    PostV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdLeadError,
    Options<PostV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdLeadData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdLead({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postV1OrganizationsByOrganizationIdSemanticMatchQueryKey = (
  options: Options<PostV1OrganizationsByOrganizationIdSemanticMatchData>
) => [createQueryKey("postV1OrganizationsByOrganizationIdSemanticMatch", options)];

export const postV1OrganizationsByOrganizationIdSemanticMatchOptions = (
  options: Options<PostV1OrganizationsByOrganizationIdSemanticMatchData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await postV1OrganizationsByOrganizationIdSemanticMatch({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: postV1OrganizationsByOrganizationIdSemanticMatchQueryKey(options),
  });
};

export const postV1OrganizationsByOrganizationIdSemanticMatchMutation = (
  options?: Partial<Options<PostV1OrganizationsByOrganizationIdSemanticMatchData>>
) => {
  const mutationOptions: UseMutationOptions<
    PostV1OrganizationsByOrganizationIdSemanticMatchResponse,
    PostV1OrganizationsByOrganizationIdSemanticMatchError,
    Options<PostV1OrganizationsByOrganizationIdSemanticMatchData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postV1OrganizationsByOrganizationIdSemanticMatch({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getV1OrganizationsByOrganizationIdLeadsByLeadIdMatchStreamQueryKey = (
  options: Options<GetV1OrganizationsByOrganizationIdLeadsByLeadIdMatchStreamData>
) => [createQueryKey("getV1OrganizationsByOrganizationIdLeadsByLeadIdMatchStream", options)];

export const getV1OrganizationsByOrganizationIdLeadsByLeadIdMatchStreamOptions = (
  options: Options<GetV1OrganizationsByOrganizationIdLeadsByLeadIdMatchStreamData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await getV1OrganizationsByOrganizationIdLeadsByLeadIdMatchStream({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: getV1OrganizationsByOrganizationIdLeadsByLeadIdMatchStreamQueryKey(options),
  });
};

export const getV1OrganizationsByOrganizationIdActiveLeadJobsQueryKey = (
  options: Options<GetV1OrganizationsByOrganizationIdActiveLeadJobsData>
) => [createQueryKey("getV1OrganizationsByOrganizationIdActiveLeadJobs", options)];

export const getV1OrganizationsByOrganizationIdActiveLeadJobsOptions = (
  options: Options<GetV1OrganizationsByOrganizationIdActiveLeadJobsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await getV1OrganizationsByOrganizationIdActiveLeadJobs({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: getV1OrganizationsByOrganizationIdActiveLeadJobsQueryKey(options),
  });
};

export const postV1OrganizationsByOrganizationIdProfilesByProfileIdSemanticMatchQueryKey = (
  options: Options<PostV1OrganizationsByOrganizationIdProfilesByProfileIdSemanticMatchData>
) => [
  createQueryKey("postV1OrganizationsByOrganizationIdProfilesByProfileIdSemanticMatch", options),
];

export const postV1OrganizationsByOrganizationIdProfilesByProfileIdSemanticMatchOptions = (
  options: Options<PostV1OrganizationsByOrganizationIdProfilesByProfileIdSemanticMatchData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await postV1OrganizationsByOrganizationIdProfilesByProfileIdSemanticMatch({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: postV1OrganizationsByOrganizationIdProfilesByProfileIdSemanticMatchQueryKey(options),
  });
};

export const postV1OrganizationsByOrganizationIdProfilesByProfileIdSemanticMatchMutation = (
  options?: Partial<
    Options<PostV1OrganizationsByOrganizationIdProfilesByProfileIdSemanticMatchData>
  >
) => {
  const mutationOptions: UseMutationOptions<
    PostV1OrganizationsByOrganizationIdProfilesByProfileIdSemanticMatchResponse,
    PostV1OrganizationsByOrganizationIdProfilesByProfileIdSemanticMatchError,
    Options<PostV1OrganizationsByOrganizationIdProfilesByProfileIdSemanticMatchData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postV1OrganizationsByOrganizationIdProfilesByProfileIdSemanticMatch({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getV1OrganizationsByOrganizationIdLeadsByLeadIdMatchResultsQueryKey = (
  options: Options<GetV1OrganizationsByOrganizationIdLeadsByLeadIdMatchResultsData>
) => [createQueryKey("getV1OrganizationsByOrganizationIdLeadsByLeadIdMatchResults", options)];

export const getV1OrganizationsByOrganizationIdLeadsByLeadIdMatchResultsOptions = (
  options: Options<GetV1OrganizationsByOrganizationIdLeadsByLeadIdMatchResultsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey }) => {
      const { data } = await getV1OrganizationsByOrganizationIdLeadsByLeadIdMatchResults({
        ...options,
        ...queryKey[0],
        throwOnError: true,
      });
      return data;
    },
    queryKey: getV1OrganizationsByOrganizationIdLeadsByLeadIdMatchResultsQueryKey(options),
  });
};
